import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { _AbcButtonComponent, _AbcScrollViewComponent, _AbcTextAreaComponent } from '@barthauer/abc/ui-components';
import { UserService } from '@barthauer/basys/core/authentication';

import {
  DxBoxModule,
  DxButtonModule,
  DxListComponent,
  DxListModule,
  DxScrollViewModule,
  DxTextAreaModule,
} from 'devextreme-angular';
import { Observable } from 'rxjs';
import { DataService } from '../../../services/data.service';
import { DeleteMode } from '../models/comment.model';
import { CommentsService } from './comments-popup.service';
import { CommentModel } from '@barthauer/abc/common-editors';
import { first } from 'rxjs/operators';

@Component({
  selector: 'comments-popup',
  templateUrl: './comments-popup.component.html',
  styleUrls: ['./comments-popup.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxBoxModule,
    DxListModule,
    DxTextAreaModule,
    DxButtonModule,
    DxScrollViewModule,
    FlexLayoutModule,
    _AbcScrollViewComponent,
    _AbcTextAreaComponent,
  ],
})
export class CommentsPopupComponent implements OnInit, OnChanges {
  @ViewChild('commentTextArea') dxTextArea: _AbcTextAreaComponent;
  @ViewChild('commentlist') dxlist: DxListComponent;
  @ViewChild('saveButton') dxbutton: _AbcButtonComponent;

  @Input() comments: CommentModel[] = [];
  @Input() item: CommentModel;
  @Input() visibleComments: CommentModel;
  @Input() itemId: number;
  @Input() deleteMode = DeleteMode.Static;
  @Input() height: string;
  @Input() geoDs: boolean = false;
  
  public flag: boolean = false;
  public comment: CommentModel = new CommentModel(null);
  private user;
  public commentText: string;

  constructor(
    private persistenceService: PersistenceService,
    private userService: UserService,
    private commentsService: CommentsService,
    private coreDataService: CoreDataService,
    public dataService: DataService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.userService.getCurrentLoginInfo().subscribe((data) => {
      this.user = data;
    });
  }
  private subtractHours(date) {
    date.setHours(date.getHours() - 1);

    return date;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.geoDs) {
      if (changes.itemId.currentValue != changes.itemId.previousValue) {
        this.comments = [];
        this.getComments(changes.itemId.currentValue).pipe(first()).subscribe((comments) => {
          if (comments?.length > 0) {
            this.comments= comments;
          }
        });
      }
    }
  }

  public deleteCommentGeoDs(id: string): Observable<any> {
    const persistQuery: PersistObjectModel = new PersistObjectModel();
    const targetObject: TargetObjectData = new TargetObjectData();
    targetObject.Mode = PersistMode.Delete;
    targetObject.ObjectKey = new ObjectKey();
    targetObject.ObjectKey.Id = id;
    targetObject.ObjectKey.ObjectType = 'Comment';
    persistQuery.Object = targetObject;
    return this.persistenceService.executePersistObjectQuery(persistQuery);
  }

  public getComments(id): Observable<any> {
    const commentQuery: Query = new Query();
    const commentQueryColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('Text', 'Text'),
      this.coreDataService.createQueryColumn('SysDateInsert', 'SysDateInsert', QueryColumnSortOrder.Descending),
      this.coreDataService.createQueryColumn('SysTimeInsert', 'SysTimeInsert', QueryColumnSortOrder.Descending),
      this.coreDataService.createQueryColumn('SysUserNameInsert', 'SysUserNameInsert'),
    ];
    commentQuery.OPath = `ParentId='${id?.toString()}'`;
    commentQuery.ObjectType = 'Comment';
    commentQuery.Columns = commentQueryColumns;

    const commentQueryDocument: QueryObjectsModel = new QueryObjectsModel();
    commentQueryDocument.ObjectQueries = [commentQuery];

    return this.coreDataService.executeReadObjectsQuery(commentQueryDocument);
  }

  public addComment(): void {
    if (this.commentText) {
      this.comment.Text = this.commentText;
      this.commentsService.persistComment(this.comment, this.itemId.toString()).subscribe(
        (data) => {
          if (!this.comments) this.comments = [];

          this.comments.unshift(
            new CommentModel({
              Id: data.Id,
              Text: this.comment.Text,
              SysDateInsert: this.datePipe.transform(new Date(), 'yyyy-MM-dd').toString(),
              SysTimeInsert: this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss').toString(),
              SysUserNameInsert: this.user.userName,
            })
          );

          this.dxlist.instance.reload();
          this.commentText="";
          this.cdr.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }
  public deleteComment(event): void {
    this.deleteCommentGeoDs(event.itemData.Id).subscribe();
  }

  public updateComment(event): void {
    // this.flag = true;
    // this.dxbutton.icon = 'save'
    // this.dxTextArea.value = event.itemData.text;
    // if (this.dxTextArea.value != event.itemData.text) {
    //   this.comment.text = this.dxTextArea.value;
    // }
  }

  public calculateDuration(commentDate): number {
    const difference = Date.now() - Date.parse(commentDate);
    const hours = Math.floor(difference / (60 * 60 * 1000));
    return hours;
  }
}
